export interface SensorReading {
  timestamp: string;
  value: number;
}

export interface SensorData {
  id: string;
  name: string;
  type: string;
  lastSeen: string;
  values: {
    key: string;
    label: string;
    current: number;
    unit: string;
    history: SensorReading[];
  }[];
}

export interface M3TRmonReading {
  flow_lpm?: number;
  total_liters?: number;
  accumulator?: number;
  temperature?: number;
}

export interface UserContextState {
  userId: string | null;
  isAuthenticated: boolean;
}

export enum AppState {
  LOADING = 'LOADING',
  PIN_REQUIRED = 'PIN_REQUIRED',
  DASHBOARD = 'DASHBOARD',
  ERROR = 'ERROR'
}

export interface FleetSensor {
  sensorId: string;
  deviceId: string | null;
  sensorName: string;
  // Optional per-unit label chosen for the customer. sensorName holds the
  // standard product name, shared by every unit of that product.
  alias: string | null;
  type: string;
  // What the device IS (gateway / node / telemetry), as opposed to `type`,
  // which is what it measures. Both matter: a wired meter, a battery LoRa node
  // and a gateway's own health report are all type 'water' and nothing alike.
  role: string | null;
  // Where the unit is in its life: bench / spare / deployed / rma / retired.
  status: string | null;
  notes: string | null;
  mac: string | null;
  location: string | null;
  lastSeen: string | null;
  claimedAt: string | null;
  userId: string | null;
  ownerName: string | null;
  ownerSecretLinkId: string | null;
  latestReading: Record<string, unknown> | null;
  latestReadingAt: string | null;
  messages24h: number;
  messages7d: number;
}